import { DynamicLink } from '@/reactRouterPlugins';
import { FormattedMessage } from 'react-intl';
import { LongDate } from '@/components/dateFormats';

export function GrSciCollMetadata({
  entity,
  ...props
}: {
  entity: {
    created?: string | null;
    modified?: string | null;
    modifiedBy?: string | null;
    masterSourceMetadata?: { source: string; sourceId: string } | null;
  };
}) {
  if (!entity) return null;
  return (
    <div className="g-text-slate-500 g-flex g-flex-wrap g-items-center g-gap-8" {...props}>
      <div>
        <FormattedMessage id="grscicoll.entryCreated" defaultMessage="Entry created" />:{' '}
        <LongDate value={entity.created!} />
      </div>
      <div>
        <FormattedMessage id="grscicoll.lastModified" defaultMessage="Last modified" />:{' '}
        <LongDate value={entity.modified!} />
      </div>
      <div>
        <FormattedMessage id="grscicoll.modifiedBy" defaultMessage="Modified by" />:{' '}
        {entity.modifiedBy}
      </div>
      {entity.masterSourceMetadata && (
        <div>
          <span>
            <FormattedMessage id="grscicoll.masterSource" defaultMessage="Master source" />:{' '}
          </span>
          {entity.masterSourceMetadata.source === 'ORGANIZATION' && (
            <DynamicLink
              className="g-underline g-text-inherit"
              pageId="publisherKey"
              variables={{ key: entity.masterSourceMetadata.sourceId }}
            >
              GBIF publisher
            </DynamicLink>
          )}
          {entity.masterSourceMetadata.source === 'DATASET' && (
            <DynamicLink
              className="g-underline g-text-inherit"
              pageId="datasetKey"
              variables={{ key: entity.masterSourceMetadata.sourceId }}
            >
              GBIF Dataset
            </DynamicLink>
          )}
          {entity.masterSourceMetadata.source === 'IH_IRN' && (
            <a
              className="g-underline g-text-inherit"
              href={`http://sweetgum.nybg.org/science/ih/herbarium-details/?irn=${entity.masterSourceMetadata.sourceId}`}
            >
              Index Herbariorum
            </a>
          )}
        </div>
      )}
    </div>
  );
}
